(function () {
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function toggleMenu(open) {
    var menu = qs("[data-sw-mobile-menu]");
    if (!menu) return;
    menu.classList.toggle("is-open", open);
    document.documentElement.style.overflow = open ? "hidden" : "";
  }

  function bindHeader() {
    qsa("[data-sw-menu-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        toggleMenu(true);
      });
    });
    qsa("[data-sw-menu-close], [data-sw-mobile-menu] a").forEach(function (item) {
      item.addEventListener("click", function () {
        toggleMenu(false);
      });
    });
  }

  function bindAccordions() {
    qsa("[data-sw-accordion]").forEach(function (accordion) {
      qsa("[data-sw-accordion-button]", accordion).forEach(function (button) {
        button.addEventListener("click", function () {
          var item = button.closest("[data-sw-accordion-item]");
          if (!item) return;
          item.classList.toggle("is-open");
          button.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
        });
      });
    });
  }

  function activeValues(group) {
    return qsa(".is-active", group).map(function (item) {
      return item.getAttribute("data-filter-value");
    }).filter(Boolean);
  }

  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function bindHomeInventory() {
    var root = qs("[data-sw-home-inventory]");
    if (!root) return;

    var cards = qsa("[data-watch-card]", root);
    var empty = qs("[data-sw-home-empty]", root);
    var buttons = qsa("[data-sw-home-brand]", root);

    function apply(selectedBrand) {
      var visible = 0;
      cards.forEach(function (card) {
        var cardBrand = card.getAttribute("data-brand") || "";
        var matches = selectedBrand === "all" || cardBrand === selectedBrand;
        card.classList.toggle("is-hidden", !matches);
        if (matches) visible += 1;
      });
      if (empty) empty.classList.toggle("is-visible", visible === 0);
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var brand = button.getAttribute("data-sw-home-brand") || "all";
        buttons.forEach(function (item) {
          item.classList.toggle("is-active", item === button);
        });
        apply(brand);
      });
    });

    apply("all");
  }

  function bindInventory() {
    var root = qs("[data-sw-inventory]");
    if (!root) return;

    var sidebar = qs("[data-sw-sidebar]", root);
    var toggle = qs("[data-sw-filter-toggle]", root);
    var cards = qsa("[data-watch-card]", root);
    var empty = qs("[data-sw-empty]", root);
    var count = qs("[data-sw-result-count]", root);
    var search = qs("[data-sw-search]", root);
    var sort = qs("[data-sw-sort]", root);
    var clear = qs("[data-sw-clear]", root);
    var activeTagWrap = qs("[data-sw-active-tags]", root);

    cards.forEach(function (card, index) {
      card.setAttribute("data-original-index", String(index));
    });

    if (toggle && sidebar) {
      toggle.addEventListener("click", function () {
        sidebar.classList.toggle("is-open");
      });
    }

    function cardMatches(card) {
      var query = normalize(search && search.value);
      var haystack = normalize(card.getAttribute("data-search"));
      if (query && haystack.indexOf(query) === -1) return false;

      var groups = qsa("[data-filter-group]", root);
      for (var i = 0; i < groups.length; i += 1) {
        var group = groups[i];
        var key = group.getAttribute("data-filter-group");
        var selected = activeValues(group);
        if (!selected.length) continue;
        var value = String(card.getAttribute("data-" + key) || "");
        if (selected.indexOf(value) === -1) return false;
      }

      var min = qs("[data-sw-price-min]", root);
      var max = qs("[data-sw-price-max]", root);
      var year = qs("[data-sw-year]", root);
      var price = Number(card.getAttribute("data-price") || 0);
      var cardYear = Number(card.getAttribute("data-year") || 0);

      if (min && min.value !== "any" && (!price || price < Number(min.value))) return false;
      if (max && max.value !== "any" && (!price || price > Number(max.value))) return false;
      if (year && year.value !== "any" && (!cardYear || cardYear < Number(year.value))) return false;
      return true;
    }

    function renderTags() {
      if (!activeTagWrap) return;
      var tags = [];
      qsa("[data-filter-group] .is-active", root).forEach(function (item) {
        tags.push({ label: item.getAttribute("data-filter-label") || item.textContent.trim(), item: item });
      });
      if (search && search.value.trim()) {
        tags.push({ label: '"' + search.value.trim() + '"', clearSearch: true });
      }
      activeTagWrap.innerHTML = "";
      tags.forEach(function (tag) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "sw-tag";
        button.textContent = tag.label + " x";
        button.addEventListener("click", function () {
          if (tag.clearSearch) search.value = "";
          if (tag.item) tag.item.classList.remove("is-active");
          apply();
        });
        activeTagWrap.appendChild(button);
      });
    }

    function sortCards(visible) {
      if (!sort) return visible;
      var sorted = visible.slice();

      function statusRank(card) {
        return card.getAttribute("data-status") === "in-stock" ? 0 : 1;
      }

      function positivePrice(card) {
        var price = Number(card.getAttribute("data-price") || 0);
        return Number.isFinite(price) && price > 0 ? price : null;
      }

      function arrival(card) {
        return Number(card.getAttribute("data-arrival") || 0);
      }

      function originalIndex(card) {
        return Number(card.getAttribute("data-original-index") || 0);
      }

      if (sort.value === "low") {
        sorted.sort(function (a, b) {
          var statusDifference = statusRank(a) - statusRank(b);
          if (statusDifference) return statusDifference;
          var aPrice = positivePrice(a);
          var bPrice = positivePrice(b);
          if (aPrice === null && bPrice !== null) return 1;
          if (aPrice !== null && bPrice === null) return -1;
          if (aPrice !== null && bPrice !== null && aPrice !== bPrice) return aPrice - bPrice;
          return originalIndex(a) - originalIndex(b);
        });
      } else if (sort.value === "high") {
        sorted.sort(function (a, b) {
          var statusDifference = statusRank(a) - statusRank(b);
          if (statusDifference) return statusDifference;
          var aPrice = positivePrice(a);
          var bPrice = positivePrice(b);
          if (aPrice === null && bPrice !== null) return 1;
          if (aPrice !== null && bPrice === null) return -1;
          if (aPrice !== null && bPrice !== null && aPrice !== bPrice) return bPrice - aPrice;
          return originalIndex(a) - originalIndex(b);
        });
      } else {
        sorted.sort(function (a, b) {
          var statusDifference = statusRank(a) - statusRank(b);
          if (statusDifference) return statusDifference;
          var arrivalDifference = arrival(b) - arrival(a);
          return arrivalDifference || originalIndex(a) - originalIndex(b);
        });
      }
      return sorted;
    }

    function apply() {
      var visible = cards.filter(cardMatches);
      var sorted = sortCards(visible);
      cards.forEach(function (card) {
        card.classList.add("is-hidden");
      });
      sorted.forEach(function (card) {
        card.classList.remove("is-hidden");
        if (card.parentNode) card.parentNode.appendChild(card);
      });
      if (count) {
        count.textContent = visible.length + (visible.length === 1 ? " watch" : " watches");
      }
      if (empty) empty.classList.toggle("is-visible", visible.length === 0);
      renderTags();
    }

    qsa("[data-filter-value]", root).forEach(function (button) {
      button.addEventListener("click", function () {
        var group = button.closest("[data-filter-group]");
        if (group && group.getAttribute("data-filter-group") === "status") {
          qsa("[data-filter-value]", group).forEach(function (statusButton) {
            statusButton.classList.toggle("is-active", statusButton === button);
          });
          if (sort) sort.value = button.getAttribute("data-filter-value") === "sold" ? "low" : "newest";
        } else {
          button.classList.toggle("is-active");
        }
        apply();
      });
    });
    qsa("[data-sw-quick-brand]").forEach(function (button) {
      button.addEventListener("click", function () {
        var brand = button.getAttribute("data-sw-quick-brand");
        qsa("[data-sw-quick-brand]").forEach(function (item) {
          item.classList.toggle("is-active", item === button);
        });
        qsa("[data-filter-group='brand'] [data-filter-value]", root).forEach(function (filter) {
          filter.classList.toggle("is-active", brand !== "all" && filter.getAttribute("data-filter-value") === brand);
        });
        if (sidebar && window.matchMedia("(max-width: 980px)").matches) sidebar.classList.remove("is-open");
        root.scrollIntoView({ behavior: "smooth", block: "start" });
        apply();
      });
    });
    qsa("[data-sw-price-min], [data-sw-price-max], [data-sw-year], [data-sw-sort]", root).forEach(function (field) {
      field.addEventListener("change", apply);
    });
    if (search) search.addEventListener("input", apply);
    if (clear) {
      clear.addEventListener("click", function () {
        if (search) search.value = "";
        qsa(".is-active", root).forEach(function (item) {
          item.classList.remove("is-active");
        });
        var currentInventory = qs("[data-filter-group='status'] [data-filter-value='in-stock']", root);
        if (currentInventory) currentInventory.classList.add("is-active");
        qsa("[data-sw-price-min], [data-sw-price-max], [data-sw-year]", root).forEach(function (field) {
          field.value = "any";
        });
        if (sort) sort.value = "newest";
        apply();
      });
    }
    apply();
  }

  function bindProductGallery() {
    qsa("[data-sw-product-gallery]").forEach(function (gallery) {
      var main = qs(".sw-product-main-image img", gallery);
      var thumbs = qsa("[data-sw-product-thumb]", gallery);
      var thumbRail = qs("[data-sw-product-thumbs]", gallery);
      var prev = qs("[data-sw-product-thumbs-prev]", gallery);
      var next = qs("[data-sw-product-thumbs-next]", gallery);
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var nextSrc = thumb.getAttribute("data-full-src");
          var nextAlt = thumb.getAttribute("data-alt") || "";
          if (!nextSrc) return;
          main.setAttribute("src", nextSrc);
          main.removeAttribute("srcset");
          main.setAttribute("alt", nextAlt);
          thumbs.forEach(function (item) {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });
          thumb.classList.add("is-active");
          thumb.setAttribute("aria-pressed", "true");
          if (typeof thumb.scrollIntoView === "function") {
            thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
          }
        });
      });

      function scrollThumbs(direction) {
        if (!thumbRail) return;
        var distance = Math.max(thumbRail.clientWidth * 0.72, 160);
        thumbRail.scrollBy({ left: distance * direction, behavior: "smooth" });
      }

      if (prev) {
        prev.addEventListener("click", function () {
          scrollThumbs(-1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          scrollThumbs(1);
        });
      }
    });
  }

  function bindHeroScan() {
    qsa("[data-sw-hero-scan]").forEach(function (scan) {
      var frames = qsa(".sw-hero-scan__frame", scan);
      var activeIndex = 0;
      var timer;

      if (frames.length < 2) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      function show(index) {
        frames.forEach(function (frame, frameIndex) {
          frame.classList.toggle("is-active", frameIndex === index);
        });
      }

      function start() {
        if (timer) return;
        timer = window.setInterval(function () {
          activeIndex = (activeIndex + 1) % frames.length;
          show(activeIndex);
        }, 5200);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = undefined;
      }

      scan.addEventListener("pointerenter", stop);
      scan.addEventListener("pointerleave", start);
      scan.addEventListener("focusin", stop);
      scan.addEventListener("focusout", start);
      start();
    });
  }

  function bindWatchQueryPrefill() {
    var params = new URLSearchParams(window.location.search);
    var watch = params.get("watch") || params.get("product") || "";
    var brand = params.get("brand") || "";
    var reference = params.get("reference") || params.get("ref") || "";
    var stock = params.get("stock") || params.get("stock_id") || "";
    var productHandle = params.get("handle") || "";
    var productImage = params.get("image") || "";
    var displayWatch = watch.replace(/-/g, " ");
    var displayReference = reference.replace(/-/g, " ");
    var displayStock = stock.replace(/-/g, " ");

    var reserve = qs("[data-sw-reserve]");
    if (reserve && displayWatch) {
      var reserveWatch = displayWatch;
      if (displayReference) reserveWatch += " / Ref. " + displayReference;
      if (displayStock) reserveWatch += " / Stock ID " + displayStock;
      qsa("[data-sw-watch-input]", reserve).forEach(function (field) {
        field.value = reserveWatch;
      });
      var title = qs("[data-sw-reserve-title]", reserve);
      if (title) title.textContent = "Request sourcing for " + displayWatch;

      var reserveMedia = qs("[data-sw-reserve-media]", reserve);
      var reserveImage = qs("[data-sw-reserve-image]", reserve);
      var reservePlaceholder = qs("[data-sw-reserve-image-placeholder]", reserve);
      function showReserveImage(imageUrl) {
        if (!reserveMedia || !reserveImage || !imageUrl) return;
        reserveImage.addEventListener("load", function () {
          reserveImage.hidden = false;
          reserveMedia.classList.add("has-image");
          if (reservePlaceholder) reservePlaceholder.hidden = true;
        }, { once: true });
        reserveImage.alt = (brand ? brand + " " : "") + displayWatch;
        reserveImage.src = imageUrl;
      }

      var trustedProductImage = "";
      if (productImage) {
        try {
          var parsedProductImage = new URL(productImage, window.location.origin);
          if (parsedProductImage.origin === window.location.origin || parsedProductImage.hostname === "cdn.shopify.com") {
            trustedProductImage = parsedProductImage.href;
          }
        } catch (error) {}
      }

      if (trustedProductImage) {
        showReserveImage(trustedProductImage);
      } else if (reserveMedia && reserveImage && /^[a-z0-9][a-z0-9-]*$/.test(productHandle)) {
        fetch("/products/" + encodeURIComponent(productHandle) + ".js", {
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Product image unavailable");
            return response.json();
          })
          .then(function (productData) {
            var featuredImage = productData.featured_image;
            if (!featuredImage) return;
            showReserveImage(featuredImage + (featuredImage.indexOf("?") === -1 ? "?" : "&") + "width=900");
          })
          .catch(function () {});
      }
    }

    var findForm = qs("#find-ref");
    if (findForm && (displayWatch || displayReference)) {
      findForm.value = displayReference || displayWatch;
    }

    var brandField = qs("#find-brand");
    if (brandField && brand) {
      var brandValue = brand.replace(/-/g, " ");
      var matched = false;
      qsa("option", brandField).forEach(function (option) {
        if (option.textContent.toLowerCase() === brandValue.toLowerCase()) {
          brandField.value = option.value;
          matched = true;
        }
      });
      if (!matched) brandField.value = "Other";
    }

    var notes = qs("#find-notes");
    if (notes && displayStock) {
      notes.value = "Stock ID " + displayStock;
    }
  }

  function bindEditorialReveal() {
    var main = qs("#MainContent");
    if (!main || document.body.classList.contains("sw-reveal-ready")) return;

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      document.body.classList.add("sw-reveal-disabled");
      return;
    }

    var revealItems = [];
    var revealGroups = [
      {
        selector: ".sw-kicker, .sw-eyebrow, .sw-h1, .sw-h2, .sw-h3, .sw-lede, .sw-copy, .sw-copy-muted, .sw-quote, .sw-product-meta-line, .sw-watch-card__price, .sw-action-row, .sw-hero-actions, .sw-filter-row, .sw-active-tags, .sw-results-head, .sw-legal h2, .sw-legal p, .sw-legal li, .sw-verify-list li, .sw-spec-row, .sw-footer-grid > *, .sw-footer-bottom",
        className: "sw-reveal-text",
        step: 54,
        maxDelay: 300,
        skipWithin: ".sw-watch-card, .sw-trust-item, .sw-info-card, .sw-step-card, .sw-band, .sw-form-card, .sw-quote-card, .sw-value-split, .sw-panel, .sw-contact-quick__primary, .sw-contact-quick__row"
      },
      {
        selector: ".sw-watch-display, .sw-glow",
        className: "sw-reveal-fade",
        step: 80,
        maxDelay: 220
      },
      {
        selector: ".sw-product-main-image, .sw-product-thumb-rail, .sw-product-placeholder, .sw-founder-photo, .sw-contact-media-placeholder",
        className: "sw-reveal-media",
        step: 80,
        maxDelay: 320
      },
      {
        selector: ".sw-watch-card, .sw-trust-item, .sw-info-card, .sw-step-card, .sw-band, .sw-form-card, .sw-quote-card, .sw-value-split, .sw-panel, .sw-stat, .sw-contact-quick__primary, .sw-contact-quick__row",
        className: "sw-reveal-card",
        step: 70,
        maxDelay: 360
      }
    ];

    function hasRevealAncestor(element) {
      var parent = element.parentElement;
      while (parent && parent !== main) {
        if (parent.classList && parent.classList.contains("sw-reveal")) return true;
        parent = parent.parentElement;
      }
      return false;
    }

    function revealScope(element) {
      return element.closest(".sw-product-grid, .sw-card-grid-3, .sw-card-grid-4, .sw-process-grid, .sw-trust-grid, .sw-feature-grid, .sw-form-grid, .sw-two-col, .sw-product-layout, .sw-footer, .sw-section, .sw-hero") || main;
    }

    function markReveal(element, group) {
      var count;
      var delay;
      var scope;

      if (!element || element.classList.contains("sw-reveal")) return;
      if (element.closest(".sw-mobile-menu")) return;
      if (group.skipWithin && element.closest(group.skipWithin)) return;
      if (hasRevealAncestor(element)) return;

      scope = revealScope(element);
      count = Number(scope.getAttribute("data-sw-reveal-count") || 0);
      scope.setAttribute("data-sw-reveal-count", String(count + 1));
      delay = Math.min(count * group.step, group.maxDelay);

      element.classList.add("sw-reveal", group.className);
      element.style.setProperty("--sw-reveal-delay", delay + "ms");
      revealItems.push(element);
    }

    revealGroups.forEach(function (group) {
      qsa(group.selector, main).forEach(function (element) {
        markReveal(element, group);
      });
    });

    if (!revealItems.length) return;

    document.body.classList.add("sw-reveal-ready");

    function reveal(element) {
      element.classList.add("is-revealed");
    }

    if (!("IntersectionObserver" in window)) {
      revealItems.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.04
    });

    revealItems.forEach(function (element) {
      observer.observe(element);
    });

    window.setTimeout(function () {
      revealItems.forEach(function (element) {
        var rect;
        if (element.classList.contains("is-revealed")) return;
        rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 1.08) reveal(element);
      });
    }, 420);
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindHeader();
    bindAccordions();
    bindHomeInventory();
    bindInventory();
    bindProductGallery();
    bindHeroScan();
    bindWatchQueryPrefill();
    bindEditorialReveal();
  });

  window.addEventListener("pageshow", function (event) {
    if (event.persisted && document.querySelector("[data-sw-inventory]")) {
      window.location.reload();
    }
  });
})();
